export enum ProductState {
    NOT_INSTALLED = 1,
    INSTALLED = 1 << 1,
    DELETING = 1 << 2,
    VERIFYING = 1 << 3,
    UPDATE_REQUIRED = 1 << 4,
    UPDATING = 1 << 5,
    PAUSED = 1 << 6,
    QUEUED = 1 << 7,
    INGAME = 1 << 8,
    INSTALLING = ProductState.UPDATING | ProductState.QUEUED | ProductState.PAUSED,
    BUSY = ProductState.INSTALLING | ProductState.VERIFYING | ProductState.DELETING,
}

export enum NexonlinkRegion {
    WEST = 'arena-west',
    TW = 'arena-tw',
    TH = 'arena-th',
    SEA = 'arena-sea',
}

export enum MapleMCommuId {
    TEST = 300,
    WEST = 296,
    TW = 297,
    TH = 298,
    SEA = 296,
}

export enum MapleMCommuCategory {
    MAIN_NEWS = 'main-news',
    ALL = 'All',
    ANNOUNCEMENT = 'announcement',
    PATCH_NOTES = 'patch-notes',
    TOWN_EVENTS = 'mapletown-events',
    TOWN_MARKET = 'mapletown-market',
    TOWN_NEWSLETTER = 'mapletown-newsletters',
    CATEGORY_1 = 'Category 1',
    CATEGORY_2 = 'Category 2',
    CATEGORY_3 = 'Category 3',
}

export enum MapleWorldCommuCategory {
    ALL = 'all-no-trans',
    NOTICE = 'notice',
    MAINTENANCE = 'maintenance-no-trans',
    KNOWN_ISSUES = 'known-issues',
    FEEDBACK_BUG_UPDATES = 'feedback-bug-updates',
    PATCH_NOTES = 'patch-notes',
    ONGOING_EVENTS = 'ongoing-events',
    EVENT_WINNERS = 'event-winners',
}

export const MapleWorldTestCommuBoardId = {
    [MapleWorldCommuCategory.ALL]: 5578,
    [MapleWorldCommuCategory.NOTICE]: 5581,
    [MapleWorldCommuCategory.MAINTENANCE]: 5581,
    [MapleWorldCommuCategory.KNOWN_ISSUES]: 5581,
    [MapleWorldCommuCategory.FEEDBACK_BUG_UPDATES]: 5581,
    [MapleWorldCommuCategory.PATCH_NOTES]: 5582,
    [MapleWorldCommuCategory.ONGOING_EVENTS]: 5583,
    [MapleWorldCommuCategory.EVENT_WINNERS]: 5583,
} as const;

export const MapleWorldCommuBoardId = {
    [MapleWorldCommuCategory.ALL]: 5361,
    [MapleWorldCommuCategory.NOTICE]: 5362,
    [MapleWorldCommuCategory.MAINTENANCE]: 5362,
    [MapleWorldCommuCategory.KNOWN_ISSUES]: 5362,
    [MapleWorldCommuCategory.FEEDBACK_BUG_UPDATES]: 5362,
    [MapleWorldCommuCategory.PATCH_NOTES]: 5363,
    [MapleWorldCommuCategory.ONGOING_EVENTS]: 5366,
    [MapleWorldCommuCategory.EVENT_WINNERS]: 5366,
} as const;

export const MapleStoryProductId = '10100';
